/**
 * Группирует элементы по колонкам
 * @param {T[]} items
 * @param {number} [totalCols = 2]
 * @param {number} [minItemsInFirstCol = 2]
 * @returns {T[][]}
 * @template T
 * @example
 * groupByCols([1, 2, 3, 4, 5, 6, 7], 2, 2) -> [[1, 2, 3, 4], [5, 6, 7]
 * groupByCols([1, 2, 3, 4, 5, 6], 2, 5) -> [[1, 2, 3, 4, 5], [6]]
 */
export const groupByCols = <T>(items: T[], totalCols: number = 2, minItemsInFirstCol: number = 2): T[][] => {
    const { length } = items;

    if (! length) return [];

    if (totalCols === 1) {
        return [ items ];
    }

    if (length <= minItemsInFirstCol) {
        const balance = Array.from({ length: totalCols - 1 }, () => Array(0)) as [];

        return [ items ].concat(balance);
    }

    const data: typeof items[] = [];

    let step = 0;
    let slices = Math.max(Math.ceil(length / totalCols), minItemsInFirstCol);

    for (let i = 0; i < totalCols; i++) {
        if (! i) {
            const currentItems = items.slice(step, slices);

            data.push(currentItems);

            step += currentItems.length;
        } else {
            const currentItems = items.slice(step, slices);

            data.push(currentItems);

            step += currentItems.length;
        }

        slices += slices;
    }

    return data;
};
